import {useFeaturesState} from '../../../../../Organisms/Features'
import {PermissionTypes, usePermissions} from '../../../../../Permissions'
import {Order} from '../../../Order.types'

const notCancellableStatuses = ['delivered', 'closed', 'paymentPending', 'rejected', 'cancelled']

export const useOrderCancellationButtonVisibility = (order?: Order): boolean => {
  const {getFeature} = useFeaturesState()
  const {hasPermission} = usePermissions()

  const hasChangeOrderPermission = hasPermission(PermissionTypes.CHANGE_ORDERS)
  const isOrderCancellationEnabled = getFeature('OrderIntakeOrderCancellation')
  const isOrderStatusCancellable = !notCancellableStatuses.includes(order?.orderStatus || '')
  return (
    !!order && isOrderStatusCancellable && hasChangeOrderPermission && isOrderCancellationEnabled
  )
}
